import {
  ApiClient,
  ClientDetailsApi,
  Configuration,
  IssuedProductApi,
  ReportingApi,
  SecurityApi,
  TransactionsReportingApi
} from 'bff';
export const initialiseApiClient = (apiConfig: Configuration): ApiClient => ({
  securityApi: new SecurityApi(apiConfig),
  clientDetailsApi: new ClientDetailsApi(apiConfig),
  issuedProductApi: new IssuedProductApi(apiConfig),
  transactionsReportingApi: new TransactionsReportingApi(apiConfig),
  reportingApi: new ReportingApi(apiConfig)
});
